export interface ApiResponse<T = unknown> {
  data: T;
  total: number;
}
